import React from 'react'
import './testimonials.css'
import KABIR from '../../assets/KABIR.JPG'
import ADAMA from '../../assets/adama.jpg'
import SAYON from '../../assets/sayon.jpg'

// import Swiper core and required modules
import { Pagination } from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

const data = [
  {
    avatar: ADAMA,
    name: "Adama Barry / Blackn' Beauty Cosmetics",
    review:
      "Excellent boulot, très professionnel il suffit que tu l'expliques clairement ton besoin, il te satisfait avec un meilleur délai et ses tarifs sont accessibles.Je le recommande vivement. Merci Masy design.",
  },
  {
    avatar: KABIR,
    name: 'Mohamed Kabir DRAME / PDG de Dramedin Studio',
    review:
      'Mangué est une personne sérieuse, efficace, et talentueuse, j’ai eu à travailler avec lui de nombreuses fois, dernièrement avec le dossier de sponsoring de mon projet, j’étais très très satisfait du résultat, en plus de ces qualités c’est une personne persévérante et à l’écoute',
  },
  {
    avatar: SAYON,
    name: 'Sayon Condé / PDG de Shopping Pour Tous',
    review:
      'Service bien fait et respect du cahier de charge. Je vous recommande sans réserve Masy Design. Il est à l’écoute et très disponible. Contactez le pour vos sites web , mon site est complètement fait par lui.',
  },
  {
    avatar: KABIR,
    name: 'Mohamed Kabir DRAME / PDG de Dramedin Studio',
    review:
      'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magnam id, illo placeat rerum quo voluptates officia vel, aliquid eum omnis ipsam consectetur cum pariatur atque eaque enim, vitae commodi nisi?',
  },
]

export default function Testimonials() {
  return (
    <section id='testimonial'>
      <h5>Quelques temoignages de nos Clients</h5>
      <h2>Les temoignages</h2>

      <Swiper
        className='container testimonial_container'
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className='testimonial'>
              <div className='client_avatar'>
                <img src={avatar} alt='' />
              </div>
              <h5 className='client_name'>{name}</h5>
              <small className='client_review'>{review}</small>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}
